import CoreQueries from '@/utils/input/queries';
import { ConfigEntity, ConfigList, ConfigMenu, ConfigProcess, ConfigReport } from './data';

const { ManageProcessPortalConfig } = CoreQueries;

export const getParamsSelectedConfigPortal = ({ idProcessPortal, id }) => {
  let paramsTable = {};
  switch (id) {
    case ConfigProcess.id:
      paramsTable = {
        ...ManageProcessPortalConfig.getProcessPortal,
        route: `${ManageProcessPortalConfig.getProcessPortal.route}${idProcessPortal}`,
      };
      break;
    case ConfigReport.id:
      paramsTable = {
        ...ManageProcessPortalConfig.getReportPortal,
        route: `${ManageProcessPortalConfig.getReportPortal.route}${idProcessPortal}`,
      };
      break;
    case ConfigList.id:
      paramsTable = {
        ...ManageProcessPortalConfig.getListPortal,
        route: `${ManageProcessPortalConfig.getListPortal.route}${idProcessPortal}`,
      };
      break;
    case ConfigEntity.id:
      paramsTable = {
        ...ManageProcessPortalConfig.getEntityPortal,
        route: `${ManageProcessPortalConfig.getEntityPortal.route}${idProcessPortal}`,
      };
      break;
    case ConfigMenu.id:
      paramsTable = {
        ...ManageProcessPortalConfig.getMenuPortal,
        route: `${ManageProcessPortalConfig.getMenuPortal.route}${idProcessPortal}`,
      };
      break;
    default:
      break;
  }
  return { paramsTable };
};

export const getParamsAddConfigProcessPortal = ({ idProcessPortal, idConfig, dataUpdate }) => {
  switch (idConfig) {
    case ConfigProcess.id:
      return {
        ...ManageProcessPortalConfig.updateProcessPortal,
        route: `${ManageProcessPortalConfig.updateProcessPortal.route}${idProcessPortal}`,
        data: dataUpdate,
      };
    case ConfigReport.id:
      return {
        ...ManageProcessPortalConfig.updateReportPortal,
        route: `${ManageProcessPortalConfig.updateReportPortal.route}${idProcessPortal}`,
        data: dataUpdate,
      };
    case ConfigList.id:
      return {
        ...ManageProcessPortalConfig.updateListPortal,
        route: `${ManageProcessPortalConfig.updateListPortal.route}${idProcessPortal}`,
        data: dataUpdate,
      };
    case ConfigEntity.id:
      return {
        ...ManageProcessPortalConfig.updateEntityPortal,
        route: `${ManageProcessPortalConfig.updateEntityPortal.route}${idProcessPortal}`,
        data: dataUpdate,
      };
    default:
      return {};
  }
};

/**
 * Handles duplicate validation error without clearing Ant Design validation errors
 * @param {Object} form - Ant Design form instance
 * @param {string} fieldName - Name of the field to validate
 * @param {boolean} isDuplicate - Whether the value is a duplicate
 * @param {string} duplicateErrorMessage - Error message for duplicate (translation key or message)
 * @returns {void}
 */
export const handleDuplicateValidation = (form, fieldName, isDuplicate, duplicateErrorMessage) => {
  const currentErrors = form.getFieldsError([fieldName]);
  const existingErrors = currentErrors?.[0]?.errors || [];

  let newErrors = [...existingErrors];

  if (isDuplicate) {
    if (!existingErrors.includes(duplicateErrorMessage)) {
      newErrors.push(duplicateErrorMessage);
    }
  } else {
    newErrors = existingErrors.filter((err) => err !== duplicateErrorMessage);
  }

  form.setFields([
    {
      name: fieldName,
      errors: newErrors,
    },
  ]);
};
